var _Circle, _Rect, _Rect2, _Path, _Path2, _Path3, _Path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Rect, Path } from "react-native-svg";
var SvgPinCheapest = function SvgPinCheapest(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    fill: "none",
    viewBox: "2.5 1.5 39 39"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 22,
    cy: 21,
    r: 18,
    fill: "#FFFFFF",
    stroke: "#DC2626",
    strokeWidth: 2.5
  })), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 13,
    height: 17,
    x: 13.5,
    y: 14,
    fill: "#B91C1C",
    stroke: "#991B1B",
    strokeWidth: 1.2,
    rx: 3
  })), _Rect2 || (_Rect2 = /*#__PURE__*/React.createElement(Rect, {
    width: 8,
    height: 5,
    x: 16,
    y: 17,
    fill: "#FEE2E2",
    rx: 1
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#B91C1C",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M17.5 19.5h5"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FECACA",
    d: "M20 28s-2.5-2.5-2.5-3.8c0-1.2 1.1-2.2 2.5-2.2s2.5 1 2.5 2.2c0 1.3-2.5 3.8-2.5 3.8"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#B91C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M26.5 17.5h2c1.1 0 2 .9 2 2V25c0 1.1-.9 2-2 2H28v-3"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#991B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "m28 24 2-3.5h2"
  })));
};
export default SvgPinCheapest;